<svg class="svg_icon--forward_chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <defs>
    <style>.svg_icon--forward_chevron .icon{fill:currentColor;}</style>
  </defs>
  <title>Forward</title>
  <g>
    <g>
      <path class="icon"
            d="M37.06,87.75A6.2,6.2,0,0,0,41.36,86h0L74.46,53.22a4.41,4.41,0,0,0,0-6.37L41.37,14a6.21,6.21,0,0,0-8.65,0,6.07,6.07,0,0,0,0,8.57L60.3,50,32.73,77.35a6.06,6.06,0,0,0,0,8.57A6,6,0,0,0,37,87.75Z"/>
    </g>
  </g>
</svg>